import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  logLevel: "",
  fullName: "",
  companyName: "",
  userType: "",
  authId: "",
  isAuth: "",
  checkInfo: true,
};

export const userInfo = createSlice({
  name: "userInfo",
  initialState: initialState,
  reducers: {
    updateUserInfo: (state, action) => {
      // console.log("action.payload", action.payload);
      return { ...state, ...action.payload };
      // return {test: "working?"};
    },
    resetUserInfo: () => {
      return initialState;
    },
  },
});

export const { updateUserInfo, resetUserInfo } = userInfo.actions;

export default userInfo.reducer;